import { useState, useEffect, useMemo, useCallback } from "react";
import "./Giftcard.css";
import { useNavigate } from "react-router";
import PageTemplate from "../../Templates/PageTemplate";
import TablePreset from "../../Table/TablePreset";
import { useTable } from "react-table";
import SortableHeader from "../../Table/TableComponents/SortableHeader";
import CheckboxCell from "../../Table/TableComponents/CheckboxCell";
import CheckboxHeader from "../../Table/TableComponents/CheckboxHeader";
import { BackButton, ButtonDarkBlue, ButtonLightGrey } from "../../HouseStyle/Components/Buttons";
import { ButtonBlue } from "../../HouseStyle/Components/Buttons";
import middleware from "../../Api/Middleware";
import ToastError from "../../Toasts/ToastError";
import ConfirmationModal from "../../Modals/GeneralSettings/ConfirmationModal";
import GiftcardNewModal from "./Modals/GiftcardNewModal";
import GiftcardEditModal from "./Modals/GiftcardEditModal";
import * as Icons from "../../HouseStyle/Icons";
import GiftcardSettingsModal from "./Modals/GiftcardSettingsModal";

function Giftcards() {
    const navigate = useNavigate();
    const [pagination, setPagination] = useState({
        page_size: 10,
        page: 1,
        max_items: 0,
        begin_of_page: 0,
        end_of_page: 0,
    });
    const [giftcards, setGiftcards] = useState([]);
    const [info, setInfo] = useState([]);
    const [loading, setLoading] = useState(true);
    const [loadingPage, setLoadingPage] = useState(false);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [confirmationAction, setConfirmationAction] = useState('deactivate'); // 'deactivate' or 'activate'
    const [showAddModal, setShowAddModal] = useState(false);
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [editItem, setEditItem] = useState(null); 
    const [showEditModal, setShowEditModal] = useState(false);
    const [selectedIds, setSelectedIds] = useState([]);
    const [order, setOrder] = useState({ orderBy: '', direction: '' });
    const [searchBar, setSearchBar] = useState("");
    const [expiDate,setExpiDate]=useState(0);

    const displayPrice = (num) => {
        return num.toFixed(2).replace(".", ",")
    }

    const fetchAll = async () => {
        try {
            const searchQuery = searchBar.trim() ? `&searchTerm=${encodeURIComponent(searchBar.trim())}&noSearch=["card_id", "sales_channel_id", "pin", "in_stock", "status", "created_at", "updated_at", "creator_user_id", "updator_user_id"]` : "";
            const [fetchGiftcards, fetchGiftcardsInfo,fetchExpiDate] = await Promise.all([
                middleware.get(
                    `sp/giftcardsTableAll?&page=${pagination.page}&page_size=${pagination.page_size}${order.orderBy !== '' && order.direction !== '' ? `&orderBy=${order.orderBy}&orderDirection=${order.direction}` : ''}${searchQuery}`),
                    middleware.get(
                    `sp/getActiveGiftcardsWithBalance`),
                middleware.get('settings/giftcards')
            
            ]);
            setGiftcards(fetchGiftcards.data.data);
            setInfo(fetchGiftcardsInfo.data[0]);
            setExpiDate(fetchExpiDate.data.data[0].validity_days);
            setPagination(prev => ({
                ...prev,
                max_items: fetchGiftcards.data.total,
                begin_of_page: fetchGiftcards.data.from,
                end_of_page: fetchGiftcards.data.to,
            }));
        } catch {
            ToastError('Fout bij het ophalen van de data');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchAll()
    }, [pagination.page_size, pagination.page, order, searchBar]);


    const handleSearchChange = useCallback((value) => {
        setSearchBar(value);
        setPagination(prev => ({ ...prev, page: 1 }));
    }, []);

    const deactivateGiftcard = async () => {
        try {
            const promises = selectedIds.map(id =>
                middleware.put(`giftcards`, {
                    card_id: id,
                    status: 0,
                }));
            await Promise.all(promises);
            setSelectedIds([]);
            await fetchAll();
            console.log("je moeder maar deactivation");
        } catch (error) {
            console.error("Error deactivating giftcards:", error);
        }
    };

    const activateGiftcard = async () => {
        try {
            const promises = selectedIds.map(id =>
                middleware.put(`giftcards`, {
                    card_id: id,
                    status: 1,
                }));
            await Promise.all(promises);
            setSelectedIds([]);
            await fetchAll();
            console.log("je moeder");
            
        } catch (error) {
            console.error("Error activating giftcards:", error);
        }
    };

    const handleConfirmationAction = () => {
        if (confirmationAction === 'activate') {
            activateGiftcard();
        } else {
            deactivateGiftcard();
        }
    };

    const columns = useMemo(
        () => {
            let columnsArray = [
                {
                    Header: (
                        <CheckboxHeader currentItem={giftcards} selectedIds={selectedIds} setSelectedIds={setSelectedIds} pk={'card_id'}>
                        </CheckboxHeader>
                    ),
                    accessor: "select",
                    Cell: ({ row }) => {
                        return <CheckboxCell row={row} selectedIds={selectedIds} pk={'card_id'} handleSelection={handleSelection} />
                    }
                },
                {
                    Header: () => (
                        <SortableHeader currentItem={order} setItem={setOrder} field="card_number" pos={'start'}>
                            Kaartnummer
                        </SortableHeader>
                    ),
                    accessor: "card_number",
                    Cell: ({ row }) => {
                        const formatCardNumber = (num) => {
                            if (!num) return '';
                            const str = num.toString();
                            if (str.length === 13) {
                                return `${str[0]}-${str.slice(1, 7)}-${str.slice(7, 13)}`;
                            }
                            return str.match(/.{1,4}/g)?.join('-') || str;
                        };

                        return <div className="text-start FlatTextLink" onClick={() => {setEditItem(row.original); setShowEditModal(true);}}>{formatCardNumber(row.original.card_number)}</div>;
                    }
                },
                {
                    Header: () => (
                        <SortableHeader currentItem={order} setItem={setOrder} field="balance" pos={'start'}>
                            Saldo
                        </SortableHeader>
                    ),
                    accessor: "saldo",
                    Cell: ({ row }) => {
                        return <div className="text-start BlackText">€ {displayPrice(row.original.balance)}</div>;
                    }
                },
                {
                    Header: () => (
                        <SortableHeader currentItem={order} setItem={setOrder} field="status" pos={'start'}>
                            Status
                        </SortableHeader>
                    ),
                    accessor: "status",
                    Cell: ({ row }) => {
                        let status = "Onbekend";
                        let color = "BlackText";
                        switch (row.original.status) {
                            case 0: 
                                status = "Gearchiveerd"
                                color = "OrangeText"
                                break;
                            case 1:
                                status = "Gepubliceerd"
                                color = "GreenText"
                                break;
                            case 2:
                                status = "Geblokkeerd"
                                color = "OrangeText"
                                break;
                        }
                        return <div className={`text-start ${color}`}>{status}</div>;
                    }
                },
                {
                    Header: () => (
                        <SortableHeader currentItem={order} setItem={setOrder} field="expiry_date" pos={'start'}>
                            Verloopt op
                        </SortableHeader>
                    ),
                    accessor: "expiry_date",
                    Cell: ({ row }) => {
                        const date=new Date(row.original.created_at);
                        date.setDate(date.getDate()+expiDate);
                        return <div className="text-start BlackText">{date.toLocaleDateString('nl-NL',{
                            year:'numeric',
                            month:'long',
                            weekday:'long',
                            day:'numeric'

                        })}</div>;
                    }
                },
            ];
            return columnsArray;
        },
        [order.orderBy, order.direction, selectedIds, setSelectedIds, giftcards,expiDate]
    );

    //   Table instance
    const tableInstance = useTable({ columns, data: giftcards });

    const handleSelection = (card_id, isSelected) => {
        if (isSelected) {
            setSelectedIds(previous => [...previous, card_id]);
        } else {
            setSelectedIds(previous => previous.filter(id => id !== card_id));
        }
    };

    const getRelevantSelectedIds = () => {
        const selectedGiftcards = giftcards.filter(gc => selectedIds.includes(gc.card_id));
        
        if (confirmationAction === 'activate') {
            // Only show giftcards that are NOT already active (status !== 1)
            return selectedGiftcards.filter(gc => gc.status !== 1).map(gc => gc.card_id);
        } else {
            // Only show giftcards that are NOT already archived (status !== 0)
            return selectedGiftcards.filter(gc => gc.status !== 0).map(gc => gc.card_id);
        }
    };

    return (
        <>
            <PageTemplate navbarTitle={"Cadeaukaarten"} pageIsLoading={loadingPage}>
                <ConfirmationModal
                    showConfirmaton={showConfirmationModal}
                    setShowConfirmation={(e) => setShowConfirmationModal(e)}
                    selectedIds={getRelevantSelectedIds()}
                    continueAction={handleConfirmationAction}
                    isActivation={confirmationAction === 'activate'}
                />
                <GiftcardNewModal
                    show={showAddModal}
                    setShow={setShowAddModal}
                    onSuccess={fetchAll}
                />
                <GiftcardEditModal
                    show={showEditModal}
                    setShow={setShowEditModal}
                    onSuccess={fetchAll}
                    giftcard={editItem}
                />
                <GiftcardSettingsModal
                    show={showSettingsModal}
                    setShow={setShowSettingsModal}
                    setExpiDate={setExpiDate}
                    expiDate={expiDate}
                    onSuccess={_ => {}}
                />
                <div className="w-100 d-flex flex-column">
                    <div className="d-flex justify-content-between mb-4">
                        <BackButton text={"Terug naar algemene instellingen"} onClickFunction={() => navigate("/algemene/instellingen")} />
                        <div className="d-flex flex-row gap-4">
                            <ButtonBlue icon={Icons.Add} text={"Cadeaukaart toevoegen"} onClickFunction={() => setShowAddModal(true)} />
                            <ButtonDarkBlue icon={Icons.GeneralSettings} text={"Instellingen"} onClickFunction={() => setShowSettingsModal(true)} />
                        </div>
                    </div>
                    <div className="w-100 d-flex flex-row justify-content-between mt-2 col-12">
                        <div className="card giftcard">
                            <p className="giftcardTitle mb-0">Openstaand Saldo</p>
                            <p className="giftcardText">€{info.total_balance}</p>
                        </div>
                        <div className="card giftcard">
                            <p className="giftcardTitle mb-0">Verkocht dit jaar</p>
                            <p className="giftcardText mb-0">€{info.sold_this_year}</p>
                            <p className="BlueText">(Vorig jaar: €{info.sold_last_year})</p>
                        </div>
                        <div className="card giftcard">
                            <p className="giftcardTitle mb-0">Ingewisseld dit jaar</p>
                            <p className="giftcardText mb-0">{info.redeemed_this_year}</p>
                            <p className="BlueText">(Vorig jaar: {info.redeemed_last_year})</p>
                        </div>
                        <div className="card giftcard">
                            <p className="giftcardTitle mb-0">Actieve cadeaukaarten in omloop</p>
                            <p className="giftcardText">{info.active_cards_count}</p>
                        </div>
                    </div>
                    <div className="w-100 mt-5">
                        <TablePreset
                            data={[{ 'selectedIds': selectedIds, 'tableInstance': tableInstance, 'pagination': pagination, 'primary_key': 'card_id' }]}
                            tableLoading={loading}
                            setPagination={setPagination}
                            actionOptions={[
                                { 
                                    title: "Archiveren", 
                                    function: () => {
                                        setConfirmationAction('deactivate');
                                        setShowConfirmationModal(true);
                                    }
                                },
                                { 
                                    title: "Publiceren", 
                                    function: () => {
                                        setConfirmationAction('activate');
                                        setShowConfirmationModal(true);
                                    }
                                },
                            ]}
                            searchBar={[{ shown: true, searchFunction: handleSearchChange }]}
                            handleSelection={handleSelection}
                        />
                    </div>
                </div>
            </PageTemplate>
        </>
    )
}

export default Giftcards;